export class LiveEvent {
     eventDate:string;
     deviceName:string;
     eventDetail:string;
}
